import React, { Component } from "react";
import {
  Modal,
  Input,
  Button,
  Form,
  message,
  Tooltip,
  List,
  Typography,
  Select,
  Upload,
} from "antd";

import {
  QuestionCircleOutlined,
  CopyOutlined,
  LoadingOutlined,
  MinusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import instance from "../../store/actions/instance";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";

const allowedVariables = [
  { key: "customer_name", label: "Customer's Name" },
  { key: "customer_phone", label: "Customer's Phone" },
];

const { Option } = Select;

class NewWhatsAppTemplateModal extends Component {
  formRef = React.createRef();

  state = {
    usedVariables: [],
    showVariableModal: false,
    imageUploadLoading: false,
    image: null,
    imagePreview: null,
  };

  detectUsedVariables = (text) => {
    return allowedVariables
      .filter((v) => text.includes(`{{${v.key}}}`))
      .map((v) => v.key);
  };

  handleBodyChange = (e) => {
    const body = e.target.value;
    const form = this.formRef.current;
    form.setFieldsValue({ body });
    const used = this.detectUsedVariables(body);
    this.setState({ usedVariables: used });
  };

  handleSubmit = async (values) => {
    const { usedVariables } = this.state;

    let updatedBody = values.body;
    let samplesList = [];

    usedVariables.forEach((key, index) => {
      const numbered = `{{${index + 1}}}`;
      const named = `{{${key}}}`;
      updatedBody = updatedBody.replaceAll(named, numbered);
      samplesList.push(values[`var_${key}`]);
    });

    const formData = new FormData();
    formData.append("name", values.name);
    formData.append("metabody", updatedBody);
    formData.append("body", values.body);
    formData.append("language", values.language);
    formData.append("samples", JSON.stringify(samplesList));
    formData.append("buttons", JSON.stringify(values.buttons || []));

    // IMAGE must be a FILE object
    if (this.state.image) {
      formData.append("image", this.state.image);
    }

    try {
      this.setState({ loading: true });
      const res = await instance.post("/create_whatsapp_template/", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.data.success) {
        message.success("Template submitted successfully.");
        this.props.onClose(true);
      } else {
        message.error(res.data.error || "Submission failed.");
      }
    } catch (error) {
      message.error(error.response?.data?.error || "Submission failed.");
    }
    this.setState({ loading: false });
  };

  renderVariableSampleInputs = () => {
    const { usedVariables } = this.state;

    return usedVariables.map((key) => {
      const variable = allowedVariables.find((v) => v.key === key);
      if (!variable) return null;

      return (
        <Form.Item
          key={key}
          label={`Sample for ${variable.label} ({{${key}}})`}
          name={`var_${key}`}
          rules={[{ required: true }]}
        >
          <Input placeholder={`e.g. Sample for {{${key}}}`} />
        </Form.Item>
      );
    });
  };
  // handleImageChange = (info) => {
  //   if (info.file.status === "uploading") {
  //     setLoading(true);
  //     return;
  //   }
  //   if (info.file.status === "done") {
  //     // Get this url from response in real world.
  //     getBase64(info.file.originFileObj, (url) => {
  //       setLoading(false);
  //       setImageUrl(url);
  //     });
  //   }
  // };
  render() {
    const { visible, onClose, t, config } = this.props;
    const {
      showVariableModal,
      loading,
      imageUploadLoading,
      image,
      imagePreview,
    } = this.state;
    const uploadButton = (
      <button style={{ border: 0, background: "none" }} type="button">
        {imageUploadLoading ? <LoadingOutlined /> : <PlusOutlined />}
        <div style={{ marginTop: 8 }}>{t("Upload")}</div>
      </button>
    );

    // <p
    //   className="m-0"
    //   style={{ color: "red", fontSize: 10, cursor: "pointer" }}
    //   onClick={() =>
    //     this.setState({ image: null, imagePreview: null })
    //   }
    // >
    //   {t("Delete")}
    // </p>
    return (
      <>
        <Modal
          maskClosable={false}
          visible={visible}
          title="Create WhatsApp Template"
          onCancel={() => onClose()}
          footer={null}
        >
          <Form
            layout="vertical"
            ref={this.formRef}
            onFinish={this.handleSubmit}
          >
            <Form.Item
              label="Template Name"
              name="name"
              rules={[{ required: true }]}
              normalize={
                (value) =>
                  value
                    ?.toLowerCase()
                    .replace(/[^a-z0-9]+/g, "_") // Replace non-alphanumerics with underscores
                    .replace(/^_+|_+$/g, "_") // Trim leading/trailing underscores
              }
            >
              <Input placeholder="e.g. pending_invoice" />
            </Form.Item>

            <Form.Item
              label="Language"
              name="language"
              initialValue={"en"}
              rules={[{ required: true, message: "Please select a language" }]}
            >
              <Select placeholder="Select language">
                <Option value="en">{t("English")}</Option>
                <Option value="ar">{t("Arabic")}</Option>
              </Select>
            </Form.Item>

            <Form.Item
              label="Image"
              name="image"
              rules={[{ required: false }]}
              getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList)}
            >
              <Upload
                accept="image/*"
                name="avatar"
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={false}
                beforeUpload={(file) => {
                  const isJpgOrPng =
                    file.type === "image/jpeg" || file.type === "image/png";

                  if (!isJpgOrPng) {
                    message.error("You can only upload JPG/PNG files!");
                    return Upload.LIST_IGNORE;
                  }

                  const isLt5M = file.size / 1024 / 1024 < 5;

                  if (!isLt5M) {
                    message.error("Image must be smaller than 5MB!");
                    return Upload.LIST_IGNORE;
                  }

                  const preview = URL.createObjectURL(file);
                  this.setState({ image: file, imagePreview: preview });
                  return false;
                }}
              >
                {imagePreview ? (
                  <>
                    <img
                      draggable={false}
                      src={imagePreview}
                      alt="avatar"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                      // style={{ width: 100, height: 100, borderRadius: 2 }}
                    />
                    <span
                      onClick={(e) => {
                        this.setState({ image: null, imagePreview: null });
                        e.stopPropagation();
                      }}
                      style={{
                        cursor: "pointer",
                        width: 20,
                        height: 20,
                        backgroundColor: "#ff5454",
                        borderRadius: 10,
                        padding: "0px 7px",
                        color: "white",
                        position: "absolute",
                        top: -3,
                        left: config.direction == "ltr" && -3,
                        right: config.direction == "rtl" && -3,
                        lineHeight: 1.38,
                        fontSize: 13,
                      }}
                    >
                      x
                    </span>
                  </>
                ) : (
                  uploadButton
                )}
              </Upload>
            </Form.Item>

            <Form.Item
              label={
                <>
                  {t("Message Body")}
                  <Tooltip title="Click to view available variables">
                    <Button
                      size="small"
                      type="link"
                      icon={<QuestionCircleOutlined />}
                      onClick={() => this.setState({ showVariableModal: true })}
                    >
                      {t("Show Allowed Variables")}
                    </Button>
                  </Tooltip>
                </>
              }
              name="body"
              rules={[{ required: true }]}
            >
              <Input.TextArea
                rows={5}
                placeholder="Hello {{customer_name}}, check our offers."
                onChange={this.handleBodyChange}
              />
            </Form.Item>

            {this.renderVariableSampleInputs()}

            {/* Dynamic Buttons */}
            <Form.List name="buttons">
              {(fields, { add, remove }) => (
                <>
                  {fields.map((field) => (
                    <div
                      key={field.key}
                      style={{
                        display: "flex",
                        marginBottom: 8,
                        alignItems: "baseline",
                      }}
                    >
                      <Form.Item
                        {...field}
                        name={[field.name, "type"]}
                        rules={[
                          { required: true, message: t("Please select type") },
                        ]}
                        style={{ width: 150 }}
                      >
                        <Select placeholder="Button Type">
                          <Option value="url">{t("URL")}</Option>
                          <Option value="phone_number">{t("Phone")}</Option>
                        </Select>
                      </Form.Item>

                      <Form.Item
                        {...field}
                        name={[field.name, "text"]}
                        rules={[
                          {
                            required: true,
                            message: t("Please enter text"),
                          },
                          {
                            max: 25,
                            message: t("Maximum length is 25 characters"),
                          },
                        ]}
                        style={{ flex: 1, marginLeft: 8 }}
                      >
                        <Input placeholder="Button Text" maxLength={25} />
                      </Form.Item>

                      {/* Extra field for URL or Phone */}
                      <Form.Item
                        {...field}
                        name={[field.name, "value"]}
                        rules={[
                          { required: true, message: t("Please enter value") },
                        ]}
                        style={{ flex: 1, marginLeft: 8 }}
                      >
                        <Input placeholder="URL or Phone" />
                      </Form.Item>

                      <MinusCircleOutlined
                        onClick={() => remove(field.name)}
                        style={{ marginLeft: 8 }}
                      />
                    </div>
                  ))}
                  <Form.Item>
                    <Button
                      type="dashed"
                      disabled={fields.length >= 3}
                      onClick={() => add()}
                      block
                      icon={<PlusOutlined />}
                    >
                      {t("Add Button")}
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>

            <Button type="primary" htmlType="submit" block loading={loading}>
              {t("Submit Template")}
            </Button>
          </Form>
        </Modal>

        <Modal
          title="Available Variables"
          open={showVariableModal}
          onCancel={() => this.setState({ showVariableModal: false })}
          footer={null}
        >
          <List
            dataSource={allowedVariables}
            renderItem={(item) => (
              <List.Item
                actions={[
                  <Tooltip title="Copy to clipboard" key="copy">
                    <Button
                      size="small"
                      icon={<CopyOutlined />}
                      onClick={() =>
                        navigator.clipboard.writeText(`{{${item.key}}}`)
                      }
                    />
                  </Tooltip>,
                ]}
              >
                <Typography.Text strong>{item.label}:</Typography.Text>{" "}
                <code style={{ marginLeft: 8 }}>{`{{${item.key}}}`}</code>
              </List.Item>
            )}
          />
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  config: state.config,
});

export default connect(mapStateToProps)(
  withNamespaces()(NewWhatsAppTemplateModal)
);
